import { EtapeService } from '@/features/parametres/services/etape.service';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Précharge les libellés/variants de statut (`EtapeService.statuts`) avant
 * d'afficher n'importe quelle page crédit — évite le flash "Statut N" le
 * temps que la requête réseau réponde. Une seule requête pour toute la
 * session : `chargerStatuts()` la met en cache pour les navigations suivantes.
 *
 * N'échoue jamais la navigation : chaque page a déjà son propre fallback si
 * les statuts restent indisponibles.
 */
export const creditStatutsResolver: ResolveFn<boolean> = () =>
  inject(EtapeService)
    .chargerStatuts()
    .pipe(
      map(() => true),
      catchError(() => of(true)),
    );
